export const ROUTER_STORAGE_KEY = 'rsk'
